"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

var _Chip = _interopRequireDefault(require("../Chip"));

var _Stack = _interopRequireDefault(require("../Stack"));

function Chips({
  spaceSize,
  chipProps,
  children,
  dataTestId
}) {
  return /*#__PURE__*/_react.default.createElement(_Stack.default, {
    horizontal: true,
    size: spaceSize,
    dataTestId: dataTestId ? `${dataTestId}-container` : undefined
  }, _react.Children.map(children, (child, index) => /*#__PURE__*/_react.default.createElement(_Chip.default, (0, _extends2.default)({
    unspaced: true,
    unbordered: true,
    label: child,
    size: "small",
    fontWeight: "normal",
    closeIcon: false,
    type: "rectangular",
    color: _Chip.default.COLOR.accent,
    dataTestId: dataTestId && `${dataTestId}-chip-${index}`
  }, chipProps))));
}

Chips.SIZE = _constants.SPACE_SIZE;
Chips.defaultProps = {
  spaceSize: Chips.SIZE.xsmall
};
var _default = Chips;
exports.default = _default;